import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Portal,
} from '@chakra-ui/react';
import { Icons } from '@texas/components/shared/Icons';
import { useTranslation } from 'react-i18next';
import { SupplierCoverageHeatmapViewMode } from '../shared/types';

interface Props {
  viewMode: SupplierCoverageHeatmapViewMode;
  onViewModeChange: (mode: SupplierCoverageHeatmapViewMode) => void;
}

export function ViewModeDropdown({ viewMode, onViewModeChange }: Props) {
  const { t } = useTranslation();

  const displayText =
    viewMode === 'suppliers'
      ? t('supplierCoverageHeatmap.viewMode.suppliers')
      : t('supplierCoverageHeatmap.viewMode.articles');

  return (
    <Menu isLazy={true}>
      <MenuButton
        as={Button}
        rightIcon={<Icons.ChevronDown />}
        size="sm"
        variant="ghost"
      >
        {displayText}
      </MenuButton>
      <Portal>
        <MenuList>
          <MenuItem onClick={() => onViewModeChange('suppliers')}>
            {t('supplierCoverageHeatmap.viewMode.suppliers')}
          </MenuItem>
          <MenuItem onClick={() => onViewModeChange('articles')}>
            {t('supplierCoverageHeatmap.viewMode.articles')}
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  );
}
